import { connect } from 'react-redux';
import { getExternalData } from '../../../../../../core/slices/annualPlanV2';
import { saveObjectivesBatch } from '@/core/slices/objectives';
import { fetchAnnualPlanStep1Context } from '@/core/slices/plans';
import {
  focuses,
  objectives,
  currentVersion,
  annualPlanExternalData,
  isLoadingFocuses,
  isLoadingObjectives,
  annualPlanV2ErrorMessage,
  readOnlyMode,
  selectedYear,
  scopeName,
  currentBusinessUnit,
} from '../../../../../../core/selectors';
import { RootState } from '../../../../../../core/types/state';
import DefineObjectives from '../../../../components/AnnualPlanning/FirstTerm/DefineObjectives';

const ConnectedDefineObjectives = connect(
  (state: RootState) => ({
    focuses: focuses(state),
    objectives: objectives(state),
    currentVersion: currentVersion(state),
    externalData: annualPlanExternalData(state),
    isLoadingFocuses: isLoadingFocuses(state),
    isLoadingObjectives: isLoadingObjectives(state),
    errorMessage: annualPlanV2ErrorMessage(state),
    readOnlyMode: readOnlyMode(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    currentBusinessUnit: currentBusinessUnit(state),
  }),
  {
    fetchAnnualPlanStep1Context,
    getExternalData,
    saveObjectivesBatch,
  },
)(DefineObjectives);

export default ConnectedDefineObjectives;
